var render, staticRenderFns
import script from "./PageRoutes.vue?vue&type=script&lang=js&"
export * from "./PageRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/config/PageRoutes.vue
// module id = FB0i
// module chunks = 91